/* 4Women — Desplegable de tipo de prenda.
 *
 * Ya casi no hace falta: al pasar a seleccion unica, el panel son enlaces <a>
 * de verdad. Navegan sin JavaScript, funcionan con el boton de atras y se
 * pueden abrir en otra pestaña.
 *
 * Aqui solo queda lo que el <details> nativo no sabe hacer: cerrarse al tocar
 * fuera. Delega sobre document, asi que sirve tambien cuando la coleccion se
 * re-renderiza por morph al filtrar.
 */
(() => {
  if (window.__fwFiltroTipo) return;
  window.__fwFiltroTipo = true;

  document.addEventListener('click', (ev) => {
    document.querySelectorAll('fw-filtro-tipo .fw-ft__det[open]').forEach((d) => {
      if (!d.contains(ev.target)) d.open = false;
    });
  });

  /* Escape cierra el que este abierto, como cualquier menu. */
  document.addEventListener('keydown', (ev) => {
    if (ev.key !== 'Escape') return;
    document.querySelectorAll('fw-filtro-tipo .fw-ft__det[open]').forEach((d) => {
      d.open = false;
    });
  });
})();
